import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import {
  GET_RESPONSE,
  GET_RESPONSE_MODES,
  SAVE_RESPONSE,
  SAVE_RESPONSE_MOBILE,
  SAVE_RESPONSE_MOBILE_TOKEN,
  SAVE_RESPONSE_EMAIL,
  SAVE_RESPONSE_EMAIL_TOKEN,
  SAVE_RESPONSE_FILE,
  SAVE_RESPONSE_SIGNED_FILE,
  DOWNLOAD_RESPONSE,
} from '../constants/ActionTypes'

import {
  showMessage,
  getResponseSuccess,
  getResponseModesSuccess,
  saveResponseSuccess,
  saveResponseMobileSuccess,
  saveResponseMobileTokenSuccess,
  saveResponseEmailSuccess,
  saveResponseEmailTokenSuccess,
  saveResponseFileSuccess,
  saveResponseSignedFileSuccess,
  downloadResponseSuccess,
} from '../actions/Response'

import { SERVER_IP } from '../constants/Config'
import { getClientInfo } from '../util/General'

const getResponseRequest = async response_id =>
  await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(response_id)}`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'GET',
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)

const getResponseModesRequest = async response_id =>
  await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(response_id)}/modes`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'GET',
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)

const saveResponseRequest = async formResponse => {
  const clientInfo = await getClientInfo()
  return await fetch(`${SERVER_IP}/api/responses/`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: JSON.stringify(clientInfo ? { ...formResponse, clientInfo } : formResponse),
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)
}

const saveResponseMobileRequest = async formResponse => {
  const clientInfo = await getClientInfo()
  return await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(formResponse.id)}/mobile-numbers`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: JSON.stringify(clientInfo ? { ...formResponse, clientInfo } : formResponse),
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)
}

const saveResponseMobileTokenRequest = async formResponse => {
  const clientInfo = await getClientInfo()
  return await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(formResponse.id)}/mobile-tokens`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: JSON.stringify(clientInfo ? { ...formResponse, clientInfo } : formResponse),
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)
}

const saveResponseEmailRequest = async formResponse => {
  const clientInfo = await getClientInfo()
  return await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(formResponse.id)}/email-addresses`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: JSON.stringify(clientInfo ? { ...formResponse, clientInfo } : formResponse),
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)
}

const saveResponseEmailTokenRequest = async formResponse => {
  const clientInfo = await getClientInfo()
  return await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(formResponse.id)}/email-tokens`, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: JSON.stringify(clientInfo ? { ...formResponse, clientInfo } : formResponse),
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)
}

const saveResponseFileRequest = async formResponse =>
  await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(formResponse.id)}/files`, {
    headers: {
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: formResponse.data,
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)

const saveResponseSignedFileRequest = async formResponse =>
  await fetch(`${SERVER_IP}/api/responses/${encodeURIComponent(formResponse.get('id'))}/signed-files`, {
    headers: {
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: formResponse,
    credentials: 'include',
  })
    .then(response => response.json())
    .catch(error => error)

const downloadResponseRequest = async payload =>
  await fetch(`${SERVER_IP}/pdf/pdf/unpuzzle-form-response`, {
    headers: {
      // 'x-access-token': localStorage.getItem('token'),
      // 'app-secret': APP_SECRET,
      // DEV Note: Library express-http-proxy cannot parse content types with ;
      //           in it so force it application/json if data is json format to
      //           properly pass to PDF Server!!!!
      'Content-Type': 'application/json',
      Pragma: 'no-cache',
    },
    method: 'POST',
    body: payload,
    // credentials: 'include',
  })
    .then(response => response.blob())
    .catch(error => error)

/** ***** Calls ***** */
function* getResponseCall({ payload }) {
  try {
    const response = yield call(getResponseRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(getResponseSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* getResponseModesCall({ payload }) {
  try {
    const response = yield call(getResponseModesRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(getResponseModesSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseCall({ payload }) {
  try {
    const response = yield call(saveResponseRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseMobileCall({ payload }) {
  try {
    const response = yield call(saveResponseMobileRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseMobileSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseMobileTokenCall({ payload }) {
  try {
    const response = yield call(saveResponseMobileTokenRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseMobileTokenSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseEmailCall({ payload }) {
  try {
    const response = yield call(saveResponseEmailRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseEmailSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseEmailTokenCall({ payload }) {
  try {
    const response = yield call(saveResponseEmailTokenRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseEmailTokenSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseFileCall({ payload }) {
  try {
    const response = yield call(saveResponseFileRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseFileSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* saveResponseSignedFileCall({ payload }) {
  try {
    const response = yield call(saveResponseSignedFileRequest, payload)
    if (response.auth === null || response.auth !== false)
      yield put(saveResponseSignedFileSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

function* downloadResponseCall({ payload }) {
  try {
    const response = yield call(downloadResponseRequest, payload)
    yield put(downloadResponseSuccess(response))
  } catch (error) {
    yield put(showMessage(JSON.stringify({ status: 'error', message: error })))
  }
}

/** **** takeEvery Functions *** */
export function* getResponse() {
  yield takeEvery(GET_RESPONSE, getResponseCall)
}

export function* getResponseModes() {
  yield takeEvery(GET_RESPONSE_MODES, getResponseModesCall)
}

export function* saveResponse() {
  yield takeEvery(SAVE_RESPONSE, saveResponseCall)
}

export function* saveResponseMobile() {
  yield takeEvery(SAVE_RESPONSE_MOBILE, saveResponseMobileCall)
}

export function* saveResponseMobileToken() {
  yield takeEvery(SAVE_RESPONSE_MOBILE_TOKEN, saveResponseMobileTokenCall)
}

export function* saveResponseEmail() {
  yield takeEvery(SAVE_RESPONSE_EMAIL, saveResponseEmailCall)
}

export function* saveResponseEmailToken() {
  yield takeEvery(SAVE_RESPONSE_EMAIL_TOKEN, saveResponseEmailTokenCall)
}

export function* saveResponseFile() {
  yield takeEvery(SAVE_RESPONSE_FILE, saveResponseFileCall)
}

export function* saveResponseSignedFile() {
  yield takeEvery(SAVE_RESPONSE_SIGNED_FILE, saveResponseSignedFileCall)
}

export function* downloadResponse() {
  yield takeEvery(DOWNLOAD_RESPONSE, downloadResponseCall)
}

export default function* rootSaga() {
  yield all([
    fork(getResponse),
    fork(getResponseModes),
    fork(saveResponse),
    fork(saveResponseMobile),
    fork(saveResponseMobileToken),
    fork(saveResponseEmail),
    fork(saveResponseEmailToken),
    fork(saveResponseFile),
    fork(saveResponseSignedFile),
    fork(downloadResponse),
  ])
}
